import { appInsights } from "./appInsights";

export interface ApiCallTelemetry {
  service: string;
  path: string;
  method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
  url: string;
  durationMs: number;
  success: boolean;
  statusCode?: number;
  errorMessage?: string;
  transactionId?: string;
}

function normalizePath(path: string): string {
  return String(path || "")
    .trim()
    .replace(/^\/+/, "");
}

function classifyApiAction(path: string, method: string): string {
  const normalizedPath = normalizePath(path).toLowerCase();
  const normalizedMethod = method.toUpperCase();

  if (
    normalizedMethod === "GET" ||
    normalizedPath.includes(":search") ||
    normalizedPath.includes("/search") ||
    normalizedPath.includes("/status") ||
    normalizedPath.includes("lookup") ||
    normalizedPath.includes("candidates")
  ) {
    return "read";
  }

  return "write";
}

export function trackApiCall({
  service,
  path,
  method,
  url,
  durationMs,
  success,
  statusCode,
  errorMessage,
  transactionId,
}: ApiCallTelemetry) {
  const actionType = classifyApiAction(path, method);

  appInsights.trackMetric({
    name: "pcs_api_call",
    average: durationMs,
    sampleCount: 1,
    properties: {
      service,
      path,
      method,
      url,
      success: String(success),
      statusCode: statusCode != null ? String(statusCode) : "unknown",
      actionType,
      ...(transactionId ? { transactionId } : {}),
    } as never,
  });

  appInsights.trackEvent({
    name: success ? "pcs_api_call_completed" : "pcs_api_call_failed",
    properties: {
      service,
      path,
      method,
      url,
      durationMs,
      success,
      statusCode: statusCode ?? null,
      actionType,
      ...(errorMessage ? { errorMessage } : {}),
      ...(transactionId ? { transactionId } : {}),
    },
  });
}
